// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"47488cd2","85":"3692209f","239":"271ef706","394":"e0fb052e","432":"b4cfa0b0","444":"14b8d406","457":"67256bf7","478":"2ad81ee2","529":"5082a4a1","556":"6cea91bb","711":"99974d9d","734":"4b032037","783":"705c707f","802":"c93890cf","896":"2d5d11b9","931":"142166bf"}[chunkId] + ".chunk.js";
};